import { FormHelperText, styled } from "@mui/material";



/**
 * WidgetLabelStyle component that renders a label for a widget
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.children - The label text to be displayed.
 * @returns {JSX.Element} The rendered WidgetLabelStyle component.
 * 
 * @example
 * return (
 *  <WidgetLabelStyle>
 *     {children}
 * </WidgetLabelStyle>
 * )
 * 
 */
export const WidgetLabelStyle = styled(FormHelperText, { target: 'WidgetLabelStyle' })`
    padding-top:  ${({ theme }) => theme.spacing(0.5)};
    padding-bottom:  ${({ theme }) => theme.spacing(2)};
    margin-top: 0;
    color:  ${({ theme }) => theme.vars.palette.texts.darkGreyMediumEmphasis}!important;
    font-size: 0.75rem;
`;
